import { Map } from "immutable";
import * as actionTypes from "~/store/action_types";
import { timeToDecimal, decimalToMinutes, hoursToDecimal } from "~/utils/utils.jsx";

const parent_data = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS: {
      return state.set(`has_new_comments`, !action.prevent);
    }
    case actionTypes.FETCH_LAST_VISIT_SUCCESS:
    case actionTypes.CLEAR_OBJECT_HAS_NEW_COMMENTS: {
      return state.set(`has_new_comments`, false);
    }
    case actionTypes.ANGULAR_INIT_TASK_AND_COMMENTS_MODAL:
    case actionTypes.LOAD_TASK: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { tracked_time, tracked_expenses } = result;
      return state.merge({ tracked_time, tracked_expenses });
    }
    case actionTypes.FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS: {
      const { response = {} } = action;
      const { time_tracked_directly_on_project = 0 } = response;
      return state.merge({ time_tracked_directly_on_project });
    }
    case actionTypes.ADD_TIME_RECORD_LOADING: {
      const { attributes = {} } = action;
      const { value = `0` } = attributes;
      const oldValue = state.get(`tracked_time`, 0);
      let addedValue = 0;
      if (value.toString().indexOf(":") !== -1) {
        addedValue = timeToDecimal(value);
      } else {
        addedValue = value;
      }
      const minutes = decimalToMinutes(oldValue) + decimalToMinutes(parseFloat(addedValue));
      return state.set(`tracked_time`, hoursToDecimal(0, minutes));
    }
    case actionTypes.DELETE_TIME_RECORD_SUCCESS: {
      const { response = {} } = action;
      const { result = {}, entities = {} } = response;
      const { single: id } = result;
      const { time_records = {} } = entities;
      const timeRecord = time_records[id];

      const toMerge = {};

      if (timeRecord && timeRecord.parent_type === "Task") {
        const oldValue = state.get(`tracked_time`, 0);
        const minutes = decimalToMinutes(oldValue) - decimalToMinutes(timeRecord.value);
        toMerge.tracked_time = hoursToDecimal(0, minutes);
      }

      if (timeRecord && timeRecord.parent_type === "Project") {
        const oldValue = state.get(`time_tracked_directly_on_project`, 0);
        const minutes = decimalToMinutes(oldValue) - decimalToMinutes(timeRecord.value);
        toMerge.time_tracked_directly_on_project = hoursToDecimal(0, minutes);
      }

      return state.merge(toMerge);
    }
    default:
      return state;
  }
};

const parents_data = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS: {
      let comment = action.response.entities.comments[action.id];
      let parentType = comment.parent_type;
      let parentId = comment.parent_id;
      let id = `${parentType}-${parentId}`;

      return action.loggedUserId !== comment.created_by_id
        ? state.set(id, parent_data(state.get(id), { ...action, parentType, parentId }))
        : state;
    }
    case actionTypes.FETCH_LAST_VISIT_SUCCESS:
    case actionTypes.CLEAR_OBJECT_HAS_NEW_COMMENTS: {
      let id = `${action.objectType}-${action.id}`;
      return state.set(id, parent_data(state.get(id), action));
    }
    case actionTypes.MOVE_EXPENSE_TO_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { result = {}, entities = {} } = response;
      const { single: id } = result;
      const { expenses = {} } = entities;
      const expense = expenses[id];
      const objectId = `${expense.parent_type}-${expense.parent_id}`;
      return state.set(objectId, parent_data(state.get(objectId), action));
    }
    case actionTypes.DELETE_TIME_RECORD_SUCCESS: {
      const { response = {} } = action;
      const { result = {}, entities = {} } = response;
      const { single: id } = result;
      const { time_records = {} } = entities;
      const timeRecord = time_records[id];
      const objectId = `${timeRecord.parent_type}-${timeRecord.parent_id}`;
      return state.set(objectId, parent_data(state.get(objectId), action));
    }
    case actionTypes.ADD_EXPENSE_LOADING:
    case actionTypes.ADD_TIME_RECORD_LOADING: {
      const { attributes = {} } = action;
      const { parent_type = `Task`, parent_id = 0 } = attributes;
      let id = `${parent_type}-${parent_id}`;
      return state.set(id, parent_data(state.get(id), action));
    }
    case actionTypes.ANGULAR_INIT_TASK_AND_COMMENTS_MODAL:
    case actionTypes.LOAD_TASK: {
      let id = `Task-${action.taskId}`;
      return state.set(id, parent_data(state.get(id), action));
    }
    case actionTypes.FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS: {
      let id = `Project-${action.projectId}`;
      return state.set(id, parent_data(state.get(id), action));
    }
    case actionTypes.STOPWATCHES_FETCH_OFFSET_LOADING: {
      const { request_start } = action;
      return state.set(`stopwatch_request_start`, request_start);
    }
    case actionTypes.STOPWATCHES_FETCH_OFFSET_SUCCESS: {
      const { response = {}, request_end } = action;
      const { additional_object_data = {} } = response;
      const { stopwatch_offset = 0 } = additional_object_data;
      state = state.set(`stopwatch_request_end`, request_end);
      return state.set(`stopwatch_offset`, stopwatch_offset);
    }
    case actionTypes.STOPWATCHES_FETCH_OFFSET_ERROR: {
      state = state.set(`stopwatch_request_start`, 0);
      state = state.set(`stopwatch_offset`, 0);
      return state.set(`stopwatch_request_end`, 0);
    }
    case actionTypes.FETCH_USER_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { tracked_time = {} } = result;
      Object.keys(tracked_time).forEach((taskId) => {
        const prev = state.get(`Task-${taskId}`, Map());
        state = state.set(`Task-${taskId}`, prev.set(`tracked_time`, tracked_time[taskId]));
      });
      return state;
    }
    case actionTypes.UPDATE_TASK_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result = 0 } = response;
      const { tasks = {} } = entities;
      const task = tasks[result];
      if (task) {
        const time = task.tracked_time;
        const expenses = task.tracked_expenses;
        let prev = state.get(`Task-${result}`, Map());
        prev = prev.set(`tracked_time`, time);
        prev = prev.set(`tracked_expenses`, expenses);
        state = state.set(`Task-${result}`, prev);
      }

      return state;
    }
    case actionTypes.FETCH_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { tasks = {} } = entities;
      Object.keys(tasks).forEach((key) => {
        const id = tasks[key].id;
        const time = tasks[key].tracked_time;
        const expenses = tasks[key].tracked_expenses;
        if (time) {
          let prev = state.get(`Task-${id}`, Map());
          prev = prev.set(`tracked_time`, time);
          prev = prev.set(`tracked_expenses`, expenses);
          state = state.set(`Task-${id}`, prev);
        }
      });

      return state;
    }
    case actionTypes.FETCH_TEAM_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { tracked_time = {} } = result;

      Object.keys(tracked_time).forEach((taskId) => {
        if (tracked_time[taskId] > 0) {
          const prev = state.get(`Task-${taskId}`, Map());
          state = state.set(`Task-${taskId}`, prev.set(`tracked_time`, tracked_time[taskId]));
        }
      });

      return state;
    }
    default:
      return state;
  }
};

export default parents_data;
